import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ValorDominio } from '../../_models/dominio.model';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule]
})
export class SelectComponent {
  @Input() opciones: ValorDominio[] = [];
  @Input() modo: 'select' | 'checkboxes' = 'select';
  @Input() placeholder: string = 'Seleccionar...';
  @Input() selectedValue: string = '';
  @Input() selectedValues: string[] = [];
  @Input() loading = false;
  @Input() disabled = false;
  @Input() singleSelection: boolean = false;

  @Output() selectionChange = new EventEmitter<string | string[]>();

  onSelectChange(event: Event): void {
    const select = event.target as HTMLInputElement;
    const value = select.value;
    this.selectedValue = value;
    this.selectionChange.emit(value);
  }

  onCheckboxChange(codigo: string, event: Event): void {
    const checkbox = event.target as HTMLInputElement;
    const checked = checkbox.checked;
    if (this.singleSelection) {
      if (checked) {
        this.selectedValues = [codigo];
      } else {
        this.selectedValues = [];
      }
    } else {
      if (checked) {
        if (!this.selectedValues.includes(codigo)) {
          this.selectedValues.push(codigo);
        }
      } else {
        this.selectedValues = this.selectedValues.filter(v => v !== codigo);
      }
    }
    this.selectionChange.emit(this.selectedValues);
  }

  isSelected(codigo: string): boolean {
    return this.selectedValues.includes(codigo);
  }
}